import { Component, OnInit } from '@angular/core';
import { PqrTypificationService } from '../../service/pqr-typification/pqr-typification.service';
import { PqrTypification } from '../../class/pqr-typification';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pqr-typifications',
  templateUrl: './pqr-typifications.component.html',
  styleUrls: ['./pqr-typifications.component.scss']
})
export class PqrTypificationsComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public pqrTypifications: PqrTypification[];
    public selectPqrTypification: PqrTypification;
    public departmentID: Number = 0;
    public modNew = false;
    public modView = false;
    public openPqrTypification = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    constructor(
        public departmentService: PqrTypificationService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) { }

    ngOnInit() {
        //this.getPqrTypifications();
        this.page = 1;
        this.per_page = 1000;
    }

    public loadPqrTypificationsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        this.getPqrTypifications(event.globalFilter);
    }

    public getPqrTypifications(query?: string) {
        this.departmentService.getPqrTypification(this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.pqrTypifications = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newPqrTypification() {
        this.modNew = !this.modNew;
        this.selectPqrTypification = null;
    }

    public savedPqrTypification(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectPqrTypification = null;
        this.modNew = false;
        this.getPqrTypifications();
    }

    public cancelPqrTypification (res) {
        this.selectPqrTypification = null;
        this.modNew = false;
        this.modView = false;
        this.getPqrTypifications();
    }

    public edit(department: PqrTypification) {
        this.modNew = true;
        this.selectPqrTypification = department;
        this.getPqrTypifications();
    }

    public view(department: PqrTypification) {
        this.openPqrTypification = true;
        this.selectPqrTypification = department;
        this.departmentID = department.id;
        this.modView = true;
    }

    public deleteDialog(department: PqrTypification) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(department);
            }
        });
    }

    public delete(department: PqrTypification) {
        this.departmentService.deletePqrTypification(department.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getPqrTypifications();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activePqrTypification(department: PqrTypification) {
        this.putPqrTypification(department);
    }

    public putPqrTypification(values: PqrTypification) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.departmentService.updatePqrTypification(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/pqr-typifications/pqr-typifications.component.ts